import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sk from './sk.json';
import cs from './cs.json';
import { DEFAULT_LOCALE, detectLocale, type Locale } from './detect';

export { DEFAULT_LOCALE, SUPPORTED_LOCALES, detectLocale, isLocale, persistLocale } from './detect';
export type { Locale } from './detect';

void i18n.use(initReactI18next).init({
  resources: {
    sk: { translation: sk },
    cs: { translation: cs },
  },
  lng: detectLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setI18nLocale(locale: Locale): void {
  if (i18n.language !== locale) {
    void i18n.changeLanguage(locale);
  }
}

export default i18n;
